import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _isEmpty from "lodash/isEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import LazySet from 'utils/cellSets/LazySet';
import initialState from '../../reducers/cellSets/initialState';
var getCellSets = function getCellSets() {
  return function (state) {
    var _stateToReturn$hierar, _stateToReturn$hierar2, _stateToReturn$hierar3, _stateToReturn$cellId;
    var stateToReturn = state && Object.keys(state).length ? state : initialState;
    var hierarchyLoaded = (_stateToReturn$hierar = stateToReturn.hierarchyLoaded) !== null && _stateToReturn$hierar !== void 0 ? _stateToReturn$hierar : ((_stateToReturn$hierar2 = (_stateToReturn$hierar3 = stateToReturn.hierarchy) === null || _stateToReturn$hierar3 === void 0 ? void 0 : _stateToReturn$hierar3.length) !== null && _stateToReturn$hierar2 !== void 0 ? _stateToReturn$hierar2 : 0) > 0;
    var cellIdsLoaded = (_stateToReturn$cellId = stateToReturn.cellIdsLoaded) !== null && _stateToReturn$cellId !== void 0 ? _stateToReturn$cellId : !_isEmpty(stateToReturn.properties);
    var hierarchyAccessible = !stateToReturn.loading && !stateToReturn.initialLoadPending && !stateToReturn.updatingClustering && !stateToReturn.error && hierarchyLoaded;
    var accessible = hierarchyAccessible && cellIdsLoaded;
    var properties = stateToReturn.properties;
    var propertiesWithExtraKeys = {};
    var cellIdsToReturn;
    if (!_isEmpty(properties)) {
      Object.entries(properties).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var cellIds = value.cellIds,
          cellSetKeys = value.cellSetKeys;
        if (cellIds) {
          cellIdsToReturn = new LazySet(cellIds);
        } else if (cellSetKeys) {
          cellIdsToReturn = new LazySet();
          cellSetKeys.forEach(function (sampleId) {
            var _properties$sampleId;
            // a sample under that id might not exist, but still have the sampleuuid
            // in the cellsetkeys (e.g. the experiment was subsetted)
            if ((_properties$sampleId = properties[sampleId]) !== null && _properties$sampleId !== void 0 && _properties$sampleId.cellIds) {
              cellIdsToReturn.addSet(properties[sampleId].cellIds, true);
            }
          });
        } else {
          cellIdsToReturn = new LazySet();
        }
        propertiesWithExtraKeys[key] = _objectSpread(_objectSpread({}, value), {}, {
          cellIds: cellIdsToReturn
        });
      });
    }
    return _objectSpread(_objectSpread({}, stateToReturn), {}, {
      properties: propertiesWithExtraKeys,
      accessible: accessible,
      hierarchyAccessible: hierarchyAccessible
    });
  };
};
export default createMemoizedSelector(getCellSets);